import { Icon } from '../../../components/ui/Icon';
import type { Workspace } from '../../../data/types/platform';

export interface WorkspacesProps {
  workspaces: Workspace[];
}

export function Workspaces({ workspaces }: WorkspacesProps) {
  return (
    <div className="rail-panel">
      <div className="rp-head">
        <h3>סביבות עבודה</h3>
        <span className="rp-count">{workspaces.length}</span>
        <button className="rp-more" type="button">הכל</button>
      </div>
      {workspaces.map((w) => (
        <div className="ws-row" key={w.id}>
          <div>
            <div className="ws-name">{w.he}</div>
            <div className="ws-sub">{w.sub}</div>
          </div>
          <div>
            <div className="ws-count">{w.modules} מודולים</div>
            <div className="ws-owner">{w.owner} · {w.updated}</div>
          </div>
        </div>
      ))}
      <div className="ws-new">
        <Icon name="plus" size={14} /> צור סביבת עבודה חדשה
      </div>
    </div>
  );
}
